/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ControllerGroup", ["EventListenerNativeClass"], function (context, cls) {
  /**
   * Base controller for an AUI node.
   * Manages client side life cycle representation of the node.
   * @class ControllerGroup
   * @memberOf classes
   * @extends classes.EventListenerNativeClass
   */
  class ControllerGroup extends cls.EventListenerNativeClass /** @lends classes.ControllerGroup.prototype */ {
    /**
     * @type {classes.NodeBase}
     */
    _anchorNode = null;
    /**
     * @type {classes.ControllerBase[]}
     */
    _controllers = null;

    /**
     * @param {classes.NodeBase} anchorNode bindings
     */
    constructor(anchorNode) {
      super();
      this._anchorNode = anchorNode;
      this._controllers = [];
    }

    isInstanceOf(type) {
      return this instanceof type;
    }

    addController(controller) {
      this._controllers.push(controller);
    }

    getControllers() {
      return this._controllers;
    }

    /**
     * Applies all behaviors of sub-controllers
     */
    applyBehaviors(treeModificationTrack, force) {
      for (const element of this._controllers) {
        element.applyBehaviors(treeModificationTrack, force);
      }
    }

    destroy() {
      for (const element of this._controllers) {
        element.destroy();
      }
    }

    /**
     * Get the anchor node
     * @returns {classes.NodeBase}
     */
    getAnchorNode() {
      return this._anchorNode;
    }

    getWidget() {
      if (this._controllers.length) {
        return this._controllers.at(-1).getWidget();
      }
      return null;
    }

    setStyleBasedBehaviorsDirty(noUsageCheck, noRecurse, fromPseudoSelection) {
      for (const element of this._controllers) {
        element.setStyleBasedBehaviorsDirty(noUsageCheck, noRecurse, fromPseudoSelection);
      }
    }

    ensureVisible() {}
  }

  cls.ControllerGroup = ControllerGroup;
  ControllerGroup.prototype.__name = "ControllerGroup";
});
